// Founding Class API client. Card reached via ?fc= token (bot link) or session (profile).
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export interface FoundingHighlight {
  category: string; // overall | subject | pioneer | strongest
  label: string;
}
export interface FoundingCard {
  display_name: string;
  member_number: number;
  class_year: string;
  avatar_url: string | null;
  highlights: FoundingHighlight[]; // [] => show "one of the first 25,000"
  share_code: string; // short referral_code → /first-students/<code>
}
export interface FoundingSummary {
  class_year: string;
  students_headline: number;
  questions_answered: number;
  schools: number;
  launch: string;
  tagline: string;
}

export async function getCardByToken(fc: string, src = 'direct'): Promise<FoundingCard | null> {
  const r = await fetch(`${API_BASE_URL}/founding-class/card?fc=${encodeURIComponent(fc)}&src=${encodeURIComponent(src)}`);
  return r.ok ? r.json() : null;
}

export async function getMyCard(): Promise<FoundingCard | null> {
  const token = localStorage.getItem('access_token');
  if (!token) return null;
  const r = await fetch(`${API_BASE_URL}/founding-class/my-card`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return r.ok ? r.json() : null;
}

export async function getSummary(): Promise<FoundingSummary> {
  const r = await fetch(`${API_BASE_URL}/founding-class/summary`);
  return r.json();
}

// Fire-and-forget instrumentation.
export function logFoundingEvent(event: string, opts: { fc?: string; source?: string } = {}): void {
  try {
    fetch(`${API_BASE_URL}/founding-class/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, fc: opts.fc, source: opts.source }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never let instrumentation break the page */
  }
}
